import { render, staticRenderFns } from "./BaseAcademy.vue?vue&type=template&id=7a057517&scoped=true&"
import script from "./BaseAcademy.vue?vue&type=script&lang=js&"
export * from "./BaseAcademy.vue?vue&type=script&lang=js&"
import style0 from "./BaseAcademy.vue?vue&type=style&index=0&id=7a057517&scoped=true&lang=scss&"
import style1 from "./BaseAcademy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a057517",
  null
  
)

export default component.exports